import { render, staticRenderFns } from "./paySuccessInfoBlock.vue?vue&type=template&id=163e525a&scoped=true&"
import script from "./paySuccessInfoBlock.vue?vue&type=script&lang=js&"
export * from "./paySuccessInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./paySuccessInfoBlock.vue?vue&type=style&index=0&id=163e525a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e525a",
  null
  
)

export default component.exports